var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setting-item" },
    [
      _c(
        "el-form-item",
        { attrs: { label: "最小行数" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入最小行数" },
            model: {
              value: _vm.minRows,
              callback: function($$v) {
                _vm.minRows = _vm._n($$v)
              },
              expression: "minRows"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "最大行数" } },
        [
          _c("el-input", {
            attrs: { type: "text", placeholder: "请输入最大行数" },
            model: {
              value: _vm.maxRows,
              callback: function($$v) {
                _vm.maxRows = _vm._n($$v)
              },
              expression: "maxRows"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc3db43c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fc3db43c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Setting/base_setting/SettingAutosize.vue
// module id = null
// module chunks = 